// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"91767072","226":"1f3d50e6","355":"e5410889","472":"8a47ab6b","577":"4553e117","611":"d0e69d91","640":"caa9790c","651":"18f6174d","686":"001025be","826":"337d811e","903":"6e194067","908":"22d130f1","936":"3fd8966a","980":"d847d46d","994":"3413a1bf"}[chunkId] + ".chunk.js";
};